import { Link } from 'react-router-dom';
import { Tag } from 'antd';
import { ResourceList } from '@/components/ResourceList';
import { listOrders, type Order } from '@/api/orders';
import { formatCNY, formatDateTime, truncate } from '@/utils/format';

const statusColor: Record<string, string> = {
  paid: 'green',
  pending: 'gold',
  cancelled: 'default',
  refunded: 'orange',
  failed: 'red',
};

export function OrdersListPage() {
  return (
    <ResourceList<Order>
      title="订单"
      description="cursor pagination；订单为热表，避免按 offset 翻页。"
      rowKey="id"
      pagination="cursor"
      filters={[
        { key: 'q', label: '关键字', type: 'text', placeholder: '订单号 / out_trade_no' },
        { key: 'user_id', label: '用户 ID', type: 'text', placeholder: 'usr_...' },
        { key: 'app_id', label: 'App ID', type: 'text', placeholder: '数字' },
        {
          key: 'status',
          label: '状态',
          type: 'select',
          options: [
            { value: 'pending', label: '待支付' },
            { value: 'paid', label: '已支付' },
            { value: 'cancelled', label: '已取消' },
            { value: 'refunded', label: '已退款' },
            { value: 'failed', label: '失败' },
          ],
        },
        {
          key: 'channel',
          label: '渠道',
          type: 'select',
          options: [
            { value: 'wx_miniapp', label: '微信小程序' },
            { value: 'dy_miniapp', label: '抖音小程序' },
            { value: 'h5', label: 'H5' },
            { value: 'ios', label: 'iOS' },
          ],
        },
      ]}
      fetcher={({ filters, pageSize, cursor }) => {
        const f = { ...filters } as Record<string, unknown>;
        if (typeof f.app_id === 'string') f.app_id = Number(f.app_id);
        return listOrders({ ...f, cursor, limit: pageSize } as never);
      }}
      columns={[
        {
          title: '订单号',
          dataIndex: 'id',
          render: (v) => <Link to={`/orders/${v}`}>{truncate(v, 14)}</Link>,
        },
        { title: '商户号', dataIndex: 'out_trade_no', render: (v) => truncate(v, 16) },
        { title: '用户', dataIndex: 'user_id', render: (v) => truncate(v, 12) },
        { title: 'App', dataIndex: 'app_id', render: (v) => <Tag color="blue">app#{v}</Tag> },
        { title: 'SKU', dataIndex: 'sku_code', render: (v) => v || '-' },
        {
          title: '金额',
          dataIndex: 'amount_cents',
          align: 'right',
          render: (v) => formatCNY(v),
        },
        {
          title: '状态',
          dataIndex: 'status',
          render: (v) => <Tag color={statusColor[v] || 'default'}>{v}</Tag>,
        },
        { title: '渠道', dataIndex: 'channel', render: (v) => <Tag>{v}</Tag> },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          render: (v) => formatDateTime(v),
        },
      ]}
    />
  );
}
